import { useState } from "react";
import { motion } from "framer-motion";
import { FaChartLine, FaHandshake, FaShieldAlt } from "react-icons/fa";

const BenefitCard = ({ title, description, icon: Icon }) => (
  <motion.div
    className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center"
    variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
  >
    <Icon className="text-4xl text-[var(--gold)] mb-4" />
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-gray-600">{description}</p>
  </motion.div>
);

const WhyRegisterSection = () => {
  const [benefits] = useState([
    {
      title: "Aumente su visibilidad",
      description: "Llegue a más clientes potenciales y aumente su presencia en línea.",
      icon: FaChartLine,
    },
    {
      title: "Conexiones valiosas",
      description: "Establezca relaciones con clientes y otros profesionales del sector legal.",
      icon: FaHandshake,
    },
    {
      title: "Gestión eficiente",
      description: "Acceda a herramientas para optimizar la gestión de casos y clientes.",
      icon: FaShieldAlt,
    },
  ]);

  return (
    <motion.section
      className="mb-16 px-4 sm:px-6 lg:px-8"
      initial="hidden"
      animate="visible"
      variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
    >
      <h2 className="text-3xl font-semibold mb-6 text-center text-gray-800">
        ¿Por qué registrarse?
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {benefits.map((benefit, index) => (
          <BenefitCard
            key={index}
            title={benefit.title}
            description={benefit.description}
            icon={benefit.icon}
          />
        ))}
      </div>

      <motion.div
        className="mt-8 bg-white p-6 sm:p-8 rounded-lg shadow-lg text-center max-w-3xl mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h3 className="text-2xl font-semibold text-gray-800">¡Beneficios adicionales!</h3>
        <p className="text-gray-600 mt-4">
          Únase ahora y disfrute de ventajas exclusivas como acceso a más clientes, herramientas especializadas y soporte personalizado.
        </p>
      </motion.div>
    </motion.section>
  );
};

export default WhyRegisterSection;
